import { generateTypes } from '../../utils/HttpReducerHelper';

export const resendInvite = generateTypes('FUNDING_REPORT', 'RESEND_INVITE');
